
const config = {
  firebase_config: {
    apiKey: "AIzaSyDsIUsWbRZkQa1bmpPVWwATC54ZVO_u-Eo",
    authDomain: "ideasapp-00001.firebaseapp.com",
    databaseURL: "https://ideasapp-00001.firebaseio.com",
    projectId: "ideasapp-00001",
    storageBucket: "ideasapp-00001.appspot.com",
    messagingSenderId: "136828231747"
  },
  firebase_config_dev: {
    apiKey: "AIzaSyDsIUsWbRZkQa1bmpPVWwATC54ZVO_u-Eo",
    authDomain: "ideasapp-00001.firebaseapp.com",
    databaseURL: "https://ideasapp-00001.firebaseio.com",
    projectId: "ideasapp-00001",
    storageBucket: "ideasapp-00001.appspot.com",
    messagingSenderId: "136828231747"
  },
  firebase_providers: [
    'google.com',
    'facebook.com',
    'twitter.com',
    'github.com',
    'password',
    'phone'
  ],
  initial_state: {
    theme: 'dark',
    locale: 'en'
  },
  drawer_width: 256
}

export default config



// WEBPACK FOOTER //
// ./src/config.js